import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { MILEAGE_CHECK } = ANALYTICS_CATEGORIES;

const { CLICK } = SNOWPLOW_EVENTS;

export const triggerMileageCheckModalOpenedOrClosedEvent = (isOpen: boolean): void => {
	const eventPayload = getSnowplowEventPayload({
		category: MILEAGE_CHECK,
		name: `dlr_mileage_check_modal_${isOpen ? 'opened' : 'closed'}`,
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
